const INE = 'ine';
const INE_REP_LEGAL = 'ineRepLegal';
const INE_TYPES = [INE, INE_REP_LEGAL];

const CHROME = 'Chrome';
const SAFARI = 'Safari';
const MOZILLA = 'Mozilla';
const ALLOW_BROWSERS = [CHROME, SAFARI, MOZILLA];

export {
  INE,
  INE_REP_LEGAL,
  INE_TYPES,
  CHROME,
  SAFARI,
  MOZILLA,
  ALLOW_BROWSERS,
};

export const INPUT_TABLE_TYPES = [
  'Input table signers',
  'Input table',
];

export const ERROR_TITLE_EMPTY_TABLE = 'La tabla no puede estar vacia';

export const ERROR_MESSAGE_EMPTY_TABLE = 'Para continuar, por favor agregue datos a la tabla.';

export const DEFAULT_CONFIRMATION_MESSAGE = 'Antes de continuar, por favor revise que haya añadido todos los datos necesarios para esta acción ¿Desea continuar?';
export const DEFAULT_CONFIRMATION_TITLE = 'Confirmación';
